import { IconBase, type IconWeight } from "@phosphor-icons/react"
import { forwardRef, type LegacyRef, type ReactElement } from "react"

const regularPath = (
  <>
    <path d="M176 168H80C78.4168 167.999 76.8689 168.467 75.5521 169.346C74.2354 170.225 73.209 171.475 72.603 172.938C71.997 174.4 71.8386 176.01 72.1478 177.562C72.457 179.115 73.2199 180.541 74.34 181.66L122.34 229.66C123.083 230.404 123.965 230.994 124.936 231.396C125.908 231.799 126.949 232.006 128 232.006C129.051 232.006 130.092 231.799 131.064 231.396C132.035 230.994 132.917 230.404 133.66 229.66L181.66 181.66C182.78 180.541 183.543 179.115 183.852 177.562C184.161 176.01 184.003 174.4 183.397 172.938C182.791 171.475 181.765 170.225 180.448 169.346C179.131 168.467 177.583 167.999 176 168Z" />
    <path
      opacity="0.2"
      d="M72.1523 78.4376C71.8443 79.9898 72.0036 81.5984 72.61 83.06C73.2152 84.5219 74.2403 85.7716 75.5557 86.6509C76.8711 87.5302 78.4178 87.9997 80 88H176C177.583 88.0013 179.131 87.5327 180.448 86.6538C181.765 85.7748 182.791 84.5249 183.397 83.0623C184.003 81.5997 184.161 79.9902 183.852 78.4376C183.543 76.8849 182.78 75.4588 181.66 74.34L133.66 26.34C132.917 25.5962 132.035 25.0061 131.064 24.6035C130.092 24.2009 129.051 23.9937 128 23.9937C126.949 23.9937 125.908 24.2009 124.936 24.6035C123.965 25.0061 123.083 25.5962 122.34 26.34L74.34 74.34C73.2215 75.4594 72.4602 76.8854 72.1523 78.4376Z"
    />
  </>
)

const weights = new Map<IconWeight, ReactElement>([["regular", regularPath]])

const CaretUpDownDown = forwardRef(
  (props, ref: LegacyRef<SVGSVGElement> | undefined) => (
    <IconBase ref={ref} {...props} weights={weights} />
  )
)

CaretUpDownDown.displayName = "CaretUpDownDown"

export default CaretUpDownDown
